import React, { useState } from 'react';
import Header from './Header';
import Section from '../../shared/reusables/Section';
import ExperienceSection from './ExperienceSection';
import EducationSection from './EducationSection';
import SkillsSection from './SkillsSection';
import Footer from './Footer';
import Sidebar from '../../shared/components/Sidebar';
import { useLanguage } from '../../shared/context/LanguageContext';
import { personalInfo, experiences, education, footerLinks } from '../../shared/data/data';
import '../../shared/styles/styles.css';

const Home = () => {
    const { language } = useLanguage();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const info = personalInfo(language);
    const exp = experiences(language);
    const edu = education(language);

    return (
        <div className="container">
            {!isSidebarOpen && (
                <button className="menu-btn" onClick={() => setIsSidebarOpen(true)}>☰</button>
            )}
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
            />
            <Header {...info} />
            <Section title={language === 'en' ? 'Summary' : 'Samenvatting'}>
                <p>{language === 'en'
                    ? 'Software Engineer with a passion for building clean, maintainable front-end applications.'
                    : 'Software ingenieur met een passie voor het bouwen van nette, onderhoudbare front-end applicaties.'
                }</p>
            </Section>
            <SkillsSection language={language} />
            <ExperienceSection experiences={exp} language={language} />
            <EducationSection education={edu} language={language} />
            <Footer {...footerLinks} />
        </div>
    );
};

export default Home;
